import { Box, Button, List, ListItem, Stack, useTheme } from "@mui/material";
import api from "src/store/features/api";
import { LoadingDotsWithText } from "../dca/styled-components/LoadingDots";

interface HighlightedInformationProps {
  currency: string;
  countryCode: string;
  showTransferTimes: boolean;
  showDescription: boolean;
}

function HighlightedInformation(props: HighlightedInformationProps) {
  const { currency, countryCode, showTransferTimes, showDescription } = props;
  const [generateReceiptUploadUrl, { isFetching }] = api.useLazyCreateDynamicFileUploadLinkQuery();
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      sx={{
        background: theme.palette.primary.contrastText,
        padding: "1rem",
        borderRadius: "10px",
        color: theme.palette.primary.main,
      }}>
      <Box>
        <List
          sx={{
            listStyleType: "disc",
            marginLeft: "1.5rem",
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.primary.contrastText,
          }}
          dense>
          <ListItem sx={{ display: "list-item", paddingLeft: "0.5rem" }}>
            <strong style={{ color: "#fc4c4c" }}>Attention : </strong>
            <strong>
              {`For allocation of your fiat deposit, you must email a copy of your wire transfer receipt to your broker or`}
              {/* Button click here to upload */}
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  // Generate url and redirect the user on success
                  generateReceiptUploadUrl({ reason: "Receipt Upload" })
                    .unwrap()
                    .then((response: any) => {
                      if (response.link) window.open(response.link, "_blank");
                    })
                    .catch((error) => {
                      console.error("Error generating upload URL:", error);
                    });
                }}>
                {isFetching ? (
                  <LoadingDotsWithText text="Loading your secure upload page" />
                ) : (
                  "Click here to upload Wire Receipt"
                )}
              </Button>
            </strong>
          </ListItem>
          {showTransferTimes && (
            <ListItem sx={{ display: "list-item", paddingLeft: "0.5rem " }}>
              Standard {countryCode === "US" && currency === "USD" ? "domestic" : "international"}{" "}
              wire transfer times will apply typically 2-3 business days.
            </ListItem>
          )}
          {showDescription && (
            <ListItem sx={{ display: "list-item", paddingLeft: "0.5rem " }}>
              Please do <strong>NOT</strong> include “Bitcoin”, “Crypto” or “BTC” in your payment
              description or your deposit will not be credited.
            </ListItem>
          )}
          <ListItem sx={{ display: "list-item", paddingLeft: "0.5rem" }}>
            {`To avoid heavy Foreign Currency Conversion charges by your bank, please ensure that you are sending ${currency} to our ${currency} account. If your bank attempts to convert your funds to another currency, please contact us at support@calebandbrown.com before proceeding.`}
          </ListItem>
          <ListItem sx={{ display: "list-item", paddingLeft: "0.5rem" }}>
            <strong style={{ color: "#fc4c4c" }}>Disclaimer : </strong>
            <strong>
              {`Please only send funds from a bank account held in the same name as your account held at Caleb & Brown. For example, if you hold a personal C&B account under the name John Smith, please fund the account from personal bank account registered under John Smith. Or, if you hold a business C&B account under Smith Industries, please fund the account from a bank account registered under Smith Industries. The name of the bank account funds are originating from must match your C&B account name.`}
            </strong>
          </ListItem>
        </List>
      </Box>
    </Stack>
  );
}

export default HighlightedInformation;
